module.exports = __webpack_public_path__ + "img/logo_big.68106679.png";